import React from "react";
import clsx from "clsx";

import styles from "./skeleton.module.scss";

const Skeleton = ({
	className = "",
	ariaLabel = "Loading interface...",
	variant = "rect",
	...props
}) => {
	if (variant === "rect") {
		props.width = props.width || "100%";
		props.height = props.height || "100%";

		return (
			<div
				aria-disabled="true"
				aria-label={ariaLabel}
				style={{ ...props }}
				className={clsx(styles.rect, className)}
			/>
		);
	}

	if (variant === "text") {
		props.width = props.width || "100%";
		props.height = props.height || "1rem";

		return (
			<div
				aria-disabled="true"
				aria-label={ariaLabel}
				style={{ ...props }}
				className={clsx(styles.text, className)}
			/>
		);
	}

	if (variant === "circle") {
		const r = props.r || props.width || props.height;
		return (
			<div
				aria-disabled="true"
				aria-label={ariaLabel}
				style={{ ...props, width: r, height: r }}
				className={clsx(styles.circle, className)}
			/>
		);
	}

	throw new Error("Unknown variant");
};

export default Skeleton;
